"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { usePathname } from 'next/navigation';
import { useState } from "react";
import { useAuthRefresh } from "@/hooks/useAuthRefresh";

export default function Providers({ children }: { children: React.ReactNode }) {
    useAuthRefresh();
    const createClient = () => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000,
            },
        },
    });
    const [mainQueryClient] = useState(createClient);
    const [opsQueryClient] = useState(createClient);
    const pathname = usePathname();
    const queryClient = pathname === '/ops' || pathname.startsWith('/ops/') ? opsQueryClient : mainQueryClient;

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}
